import { useCallback, useEffect, useState } from "react";
import { FileSpreadsheet, FlaskConical, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "../../lib/api";
import { saveBlob } from "../../lib/files";
import { formatDateTime } from "../../lib/format";

const OUT = [["cliente", "Se archivarían en su cliente"], ["por_clasificar", "Irían a Por clasificar"], ["ya_existia", "Repetidos (ya existía)"], ["omitido", "Se omiten"]];

const Result = ({ job, onExcel }) => (
  <div className="space-y-2" data-testid="drive-dry-result">
    <p className="text-xs text-[#5b667a]">Simulación del {formatDateTime(job.finished_at || job.started_at)} · {job.files.toLocaleString("es-MX")} archivos en Drive · no se archivó nada</p>
    <div className="grid gap-2 sm:grid-cols-4">
      {OUT.map(([k, label]) => (
        <div key={k} className="rounded-xl bg-[#f5f8fd] px-3 py-2" data-testid={`drive-dry-count-${k}`}>
          <div className="font-mono text-lg font-bold text-[#182235]">{(job.counts[k] || 0).toLocaleString("es-MX")}</div>
          <div className="text-xs font-semibold text-[#5b667a]">{label}</div>
        </div>
      ))}
    </div>
    {Object.keys(job.reasons).length > 0 && (
      <ul className="space-y-0.5 text-xs text-[#3b475c]" data-testid="drive-dry-reasons">
        {Object.entries(job.reasons).sort((a, b) => b[1] - a[1]).map(([r, n]) => <li key={r}><span className="font-mono font-bold">{n}</span> · {r}</li>)}
      </ul>
    )}
    <button type="button" onClick={onExcel} className="tr-btn-light px-3 py-1.5 text-sm" data-testid="drive-dry-excel"><FileSpreadsheet className="h-4 w-4" /> Descargar Excel de la simulación</button>
  </div>
);

export const DriveDryRun = () => {
  const [job, setJob] = useState(null);
  const running = job?.status === "en_curso";
  const load = useCallback(() => api.get("/drive/dry-run/current").then((r) => setJob(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (!running) return undefined;
    const t = setTimeout(load, 2000);
    return () => clearTimeout(t);
  }, [job, running, load]);

  const start = async () => {
    try { setJob((await api.post("/drive/dry-run")).data); } catch (e) { toast.error(errorMessage(e, "No se pudo iniciar la simulación")); }
  };
  const excel = async () => {
    try { saveBlob((await api.get(`/drive/dry-run/${job.id}/excel`, { responseType: "blob", timeout: 300000 })).data, "Simulacion sincronizacion Drive.xlsx"); }
    catch { toast.error("No se pudo generar el Excel, intenta de nuevo"); }
  };

  return (
    <div className="space-y-3 border-t border-[#e8edf5] pt-3" data-testid="drive-dry-run">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs text-[#5b667a]">Prueba sin riesgo: lee tu carpeta y te dice a qué cliente iría cada archivo, sin archivar nada.</p>
        <button type="button" onClick={start} disabled={running} className="tr-btn-light px-3 py-1.5 text-sm" data-testid="drive-dry-start">
          {running ? <Loader2 className="h-4 w-4 animate-spin" /> : <FlaskConical className="h-4 w-4" />} Simular sincronización
        </button>
      </div>
      {running && <p className="flex items-center gap-2 text-sm font-semibold" data-testid="drive-dry-progress"><Loader2 className="h-4 w-4 animate-spin text-[#0f5ef7]" />{job.step} · {job.files.toLocaleString("es-MX")} archivos encontrados</p>}
      {job?.status === "error" && <p className="text-sm font-semibold text-[#b42318]" data-testid="drive-dry-error">{job.message}</p>}
      {job?.status === "terminado" && <Result job={job} onExcel={excel} />}
    </div>
  );
};
